import { HttpStatusCode } from 'axios';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import { useHttp } from '@/composables';

export const usePlanStore = defineStore('plan', () => {
  const loading = ref(true);
  const selectedFramework = ref(null);

  const id = ref(null);
  const municipality = ref({});
  const lastPublishedAt = ref(null);
  const subtitle = ref(null);
  const logo = ref(null);
  const coverPageImage = ref(null);
  const mayorPhoto = ref(null);
  const mayorSignature = ref(null);
  const municipalManagerPhoto = ref(null);
  const municipalManagerSignature = ref(null);
  const planAnnexures = ref([]);
  const annexureTypes = ref([]);

  const content = ref(null);

  const formData = computed(() => {
    return {
      subtitle: subtitle.value,
      content: content.value,
    };
  });

  const annexureLookup = computed(() => {
    const lookup = {};

    planAnnexures.value.forEach(annexure => {
      lookup[annexure.id] = annexure;
    });

    return lookup;
  });

  const loadAnnexureTypes = async () => {
    // Return early if already loaded to prevent redundant calls
    if (annexureTypes.value.length > 0) return;

    const response = await useHttp().get('/util/annexure-types');

    if (response.statusCode === HttpStatusCode.Ok) {
      annexureTypes.value = response.data.items;
    }
  };

  return {
    loading,
    id,
    selectedFramework,
    municipality,
    lastPublishedAt,
    formData,
    subtitle,
    logo,
    coverPageImage,
    mayorPhoto,
    mayorSignature,
    municipalManagerPhoto,
    municipalManagerSignature,
    content,
    annexureTypes,
    loadAnnexureTypes,
    planAnnexures,
    annexureLookup,
  };
});

// https://gitlab.creationlabs.co.za/clients/cog01-cogta/livingplans/idp-livingplans/idp-livingplans-api/-/blob/dev/src/Validation/Schema/plan_content.json?ref_type=heads
